// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import $ from "jquery";
import axios from "axios";
import ElementUI from "element-ui";
import Methods from "@/assets/js/method.js";
// import GLOBAL from "@/assets/js/global.js";
import CryptoJS from "crypto-js";

import "element-ui/lib/theme-chalk/index.css";
import "@/assets/js/axiosConfig.js";
import "babel-polyfill";
import "@/assets/css/public.css";

import promise from 'es6-promise'
promise.polyfill()

let vm = new Vue();
const EventBus = new Vue()

// axios.defaults.baseURL = "http://lb.asp168.com:82/api"
axios.defaults.baseURL = "https://www.fedtech.cc/api"

// 抛出异常
const errorHandler = (error, vm)=>{
  console.error('抛出全局异常');
  console.error(vm);
  console.error(error);
   
}
 
Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = (error)=> errorHandler(error,this);

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$methods = Methods;
// Vue.prototype.GLOBAL = GLOBAL;
Vue.prototype.$http = axios;
Vue.prototype.CryptoJS = CryptoJS;
Vue.prototype.$vm = vm;
Vue.prototype.$EventBus = new Vue();
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  $
});



// WEBPACK FOOTER //
// ./src/main.js